import { productStatesApi } from "@/services/api/productStates.api";
import appSnackbarService from "@/services/appSnackbar.service";
import i18n from "@/services/i18n";

interface ProductStateRequest {
  sortBy: string;
  descending: string;
  page: number;
  rowsPerPage: number;
  searchString: string[];
}

interface ProductStatePost {
  data: object;
  index: number;
}

interface ProductStateDelete {
  id: number;
  index: number;
}

export const productStatesState: any = {
  namespaced: false,
  state: {
    productStates: [],
    totalItem: 0,
    total: 0,
    loading: true,
    fetching: false
  },
  mutations: {
    // load productStates
    PRODUCT_STATE_FETCH_SUCCESS(state: any, payload: any) {
      state.productStates = payload.data;
      state.total = payload.data.length;
      state.totalItem = payload.totalCount;
      state.loading = false;
      state.fetching = false;
    },
    PRODUCT_STATE_FETCH_START(state: any) {
      state.fetching = true;
    },
    PRODUCT_STATE_FETCH_ERROR(state: any, payload: any) {
      state.fetching = false;
      state.error = payload;
    },

    // save
    PRODUCT_STATE_SAVE_SUCCESS(state: any, payload: any) {
      if (payload.index > -1) {
        // update
        state.productStates.splice(payload.index, 1, payload.data);
      } else {
        // add
        state.productStates.push(payload.data);
      }
    },
    PRODUCT_STATE_SAVE_START(state: any) {
      state.fetching = true;
    },
    PRODUCT_STATE_SAVE_ERROR(state: any, payload: any) {
      state.fetching = false;
      state.error = payload;
    },

    // delete
    PRODUCT_STATE_DELETE_SUCCESS(state: any, payload: any) {
      if (payload.index > -1) {
        state.productStates.splice(payload.index, 1);
        state.loading = false;
      }
    },
    PRODUCT_STATE_DELETE_START(state: any) {
      state.fetching = true;
      state.loading = true;
    },
    PRODUCT_STATE_DELETE_ERROR(state: any, payload: any) {
      state.fetching = false;
      state.error = payload;
      state.loading = false;
    },
  },
  actions: {
    getProductStates({ commit }: any, request: ProductStateRequest) {
      commit("PRODUCT_STATE_FETCH_START");

      const promise = new Promise((resolve, reject) => {
        productStatesApi
          .getAll(request)
          .then(response => {
            commit("PRODUCT_STATE_FETCH_SUCCESS", response.data);
            resolve(response);
          })
          .catch(error => {
            commit("PRODUCT_STATE_FETCH_ERROR", error);
            reject(error);
          });
      });
      return promise;
    },
    saveProductState({ commit }: any, payload: ProductStatePost) {
      commit("PRODUCT_STATE_SAVE_START");
      const editedIndex = payload.index;

      const promise = new Promise((resolve, reject) => {
        productStatesApi
          .save(payload.data)
          .then(response => {
            commit("PRODUCT_STATE_SAVE_SUCCESS", {
              data: response.data,
              index: editedIndex
            });
            appSnackbarService.success(i18n.t("SUCCESS_MESSAGES.PRODUCT_STATE_SAVED"));
            resolve(response);
          })
          .catch(error => {
            commit("PRODUCT_STATE_SAVE_ERROR", error);
            reject(error);
          });
        });
      return promise;
    },
    deleteProductState({ commit }: any, payload: ProductStateDelete) {
      commit("PRODUCT_STATE_DELETE_START");

      const deletedIndex = payload.index;
      productStatesApi
        .delete(payload.id)
        .then(response => {
          commit("PRODUCT_STATE_DELETE_SUCCESS", {
            data: response.data,
            index: deletedIndex
          });
          appSnackbarService.warning(i18n.t("SUCCESS_MESSAGES.PRODUCT_STATE_DELETED"));

        })
        .catch(error => {
          commit("PRODUCT_STATE_DELETE_ERROR", error);
        });
    },
  }
};
